import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * Determines if Multi-Context Canvas can be accessed and used in the current Designer state.
 *
 * Multi-Context Canvas is supported when:
 * - User can access Design or Edit site mode
 * - In Canvas workflow
 * - NOT on a component canvas page (It already uses the open canvas experience)
 * - Not when editing interactions (IX2/IX3 don't work well with multi-context)
 *
 *
 */
export const canAccessMultiContextCanvas = defineAbilityConfig([
  {
    userTypes: {
      authorizedInDesigner: true,
    },
    siteModes: {design: true, edit: true},
    workflows: {
      canvas: true,
    },
    pageTypes: {
      componentCanvas: false,
    },
    hasSelectedInteractions: false,
  },
] as const);
